<template>
  <div style="background: #fff;">
    <div class="proofingProgess__control">
      <el-button type="primary" @click="handlePrint">打印</el-button>
    </div>
    <div class="table-item-print__contain">
      <div class="table-item-print">
        <div class="head">
          <div class="head-top">
            <div class="left important font_style">
              {{ printInfo.brandCode | upperString }}
            </div>
            <div class="main important">{{ printInfo.company }}</div>
            <div class="right"></div>
          </div>
          <div class="head-bottom">
            <div class="head__main important">{{ title }}</div>
            <div class="head__left">
              <span class="year">{{ printInfo.years }}</span>
              年
              <span class="month">({{ printInfo.periods }})</span>
              期
            </div>
            <div class="head__right">{{ group }}</div>
          </div>
        </div>
        <div class="main">
          <div class="main__item_1">面料手感样</div>
          <div class="main__item_2">
            <div class="main__item_2__big">
              面料编号:{{ printInfo.relatedMaterialCode }}
            </div>
            <div class="main__item_2__mm empty">
              合同编号:{{ printInfo.sapPoNo }}
            </div>

            <div class="main__item_2__big">
              面料名称:{{ printInfo.materialDescCn }}
            </div>
            <div class="main__item_2__mm">面料克重:{{ printInfo.weight }}</div>

            <div class="main__item_2__big">
              面料成份:{{ printInfo.ingredient }}
            </div>
            <div class="main__item_2__mm">
              大类别:{{ printInfo.materialGroupClass }}
            </div>

            <div class="main__item_2__big">面料纱支:{{ printInfo.yarn }}</div>
            <div class="main__item_2__mm">
              小类别:{{ printInfo.materialGroupSubClass }}
            </div>

            <div class="main__item_2__mm">
              边至边幅宽(CM):{{ printInfo.sealingWidth }}
            </div>
            <div class="main__item_2__mm">
              实用幅宽(CM):{{ printInfo.actSealingWidth }}
            </div>
            <div class="main__item_2__mm empty">历史组别:</div>

            <div class="main__item_2__mm empty">
              放样价(元):{{ printInfo.loftingPrice }}
            </div>
            <div class="main__item_2__mm">
              大货价(元/):{{ printInfo.bigPrice }}
            </div>
            <div class="main__item_2__mm empty">历史单价:</div>

            <div class="main__item_2__mm empty">
              放样量(M)):{{ printInfo.loftingVolumn }}
            </div>
            <div class="main__item_2__mm">
              大货起订量(M):{{ printInfo.wearMoq }}
            </div>
            <div class="main__item_2__mm empty">成控复核:</div>

            <div class="main__item_2__mm empty">放样期(天):</div>
            <div class="main__item_2__mm">
              大货货期(天):{{ printInfo.wearDate }}
            </div>
            <div class="main__item_2__mm empty">系统维护员复核:</div>

            <div class="main__item_2__mm">
              供应商: {{ printInfo.vendorName }}
            </div>
            <div class="main__item_2__mm">
              货号：{{ printInfo.venderMaterialCode }}
            </div>
            <div class="main__item_2__mm">
              开发员: {{ printInfo.developer }}
            </div>

            <div class="main__item_2__mm empty">供应商联系电话：</div>
            <div class="main__item_2__mm"></div>
            <div class="main__item_2__mm empty">供应商联系人：</div>
            <div class="main__item_2__sbig">备注:{{ printInfo.comments }}</div>
          </div>

          <div class="main__item_3">
            <div class="main-middle__top__mm">
              色号:{{ colorList[0].colorCode }}-{{ colorList[0].colorDesc }}
            </div>
            <div class="main-middle__top__mm">
              色号:{{ colorList[1].colorCode }}-{{ colorList[1].colorDesc }}
            </div>
            <div class="main-middle__top__mm">
              色号:{{ colorList[2].colorCode }}-{{ colorList[2].colorDesc }}
            </div>
            <div class="main-middle__top__mm">
              色号:{{ colorList[3].colorCode }}-{{ colorList[3].colorDesc }}
            </div>
            <div class="main-middle__left__mm">
              {{ colorList[0].colorCode }}-{{ colorList[0].ctx }}
            </div>
            <div class="main-middle__left__mm">
              {{ colorList[1].colorCode }}-{{ colorList[1].ctx }}
            </div>
            <div class="main-middle__left__mm">
              {{ colorList[2].colorCode }}-{{ colorList[2].ctx }}
            </div>
            <div class="main-middle__left__mm">
              {{ colorList[3].colorCode }}-{{ colorList[3].ctx }}
            </div>
            <div class="main-middle__top__mm">
              色号:{{ colorList[4].colorCode }}-{{ colorList[4].colorDesc }}
            </div>
            <div class="main-middle__top__mm">
              色号:{{ colorList[5].colorCode }}-{{ colorList[5].colorDesc }}
            </div>
            <div class="main-middle__top__mm">
              色号:{{ colorList[6].colorCode }}-{{ colorList[6].colorDesc }}
            </div>
            <div class="main-middle__top__mm">
              色号:{{ colorList[7].colorCode }}-{{ colorList[7].colorDesc }}
            </div>
            <div class="main-middle__left__mm">
              {{ colorList[4].colorCode }}-{{ colorList[4].ctx }}
            </div>
            <div class="main-middle__left__mm">
              {{ colorList[5].colorCode }}-{{ colorList[5].ctx }}
            </div>
            <div class="main-middle__left__mm">
              {{ colorList[6].colorCode }}-{{ colorList[6].ctx }}
            </div>
            <div class="main-middle__left__mm">
              {{ colorList[7].colorCode }}-{{ colorList[7].ctx }}
            </div>
          </div>

          <div class="main__item_4">
            <div class="main__item_4__mm empty">
              色号:{{ colorList[8].colorCode }}-{{ colorList[8].colorDesc }}
            </div>
            <div class="main__item_4__sm">复核:</div>
            <div class="main__item_4__big">{{ colorList[8].ctx }}</div>
            <div class="main__item_4__sm empty">审核:</div>
            <div class="main__item_4__sm empty">审批:</div>
            <div class="main__item_4__sm empty">设计部确认:</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as globalEnum from "src/common/global-enum";
import printUtil from "src/common/print";
export default {
  name: "tableItemPrint",
  props: {
    title: {
      type: String,
    },
  },
  filters: {
    upperString(val) {
      if (!val) return val;
      return globalEnum.BrandCodeToBrandName[val].toUpperCase();
    },
  },
  computed: {
    group() {
      const materialCode = this.printInfo.materialCode;
      const relatedMaterialCode = this.printInfo.relatedMaterialCode;
      if (materialCode && !relatedMaterialCode) return materialCode;
      if (!materialCode && relatedMaterialCode) return relatedMaterialCode;
      if (materialCode && relatedMaterialCode)
        return `${materialCode}/${relatedMaterialCode}`;
    },
    colorList() {
      const instances = this.printInfo.instances;
      let array = [];
      for (let i = 0; i <= 8; i++) {
        array.push({
          colorCode: "",
          colorDesc: "",
          memo: "",
          status: "",
          ctx: "",
        });
      }
      if (!instances) return array;
      if (instances.length < 0) return array;
      this.printInfo.instances.forEach((item, $index) => {
        array[$index] = item;
        array[$index].ctx = item.memo;
      });
      console.log(array);
      return array;
    },
  },
  methods: {
    handlePrint() {
      setTimeout(() => {
        printUtil(
          ".table-item-print__contain",
          "面料打样打印",
          "print_tableItemPrint",
          "table-item-print"
        );
      }, 0);
    },
  },
  mounted() {
    let id = this.$route.query.id;
    this.$apis.autoAPi
      .POST_MATERIAL_INFO_PRINT({
        id,
      })
      .done((resp) => {
        this.printInfo = resp.data;
      })
      .fail((err) => {});
  },
  data() {
    return {
      tableInfo: {
        head: {
          title: "面料开发资料表",
          date: {
            year: 2019,
            num: 1,
          },
          group: "面料组别",
          link: "关联组别",
        },
        main: {
          feel: "面料手感样",
        },
      },
      printInfo: {},
    };
  },
};
</script>

<style>
/* @import '/static/resources/print_tableItemPrint.css'; */
</style>
